import { ChevronLeft } from 'lucide-react';

export default function SettingsSectionCard({ icon, title, description, badge, badgeColor = 'emerald', onClick, children }) {
  const badgeColors = {
    emerald: 'bg-emerald-100 text-emerald-700',
    red: 'bg-red-100 text-red-700',
    amber: 'bg-amber-100 text-amber-700',
    blue: 'bg-blue-100 text-blue-700',
  };

  return (
    <button
      onClick={onClick}
      className="w-full bg-card border border-border rounded-2xl p-4 flex items-center gap-4 text-right hover:border-primary/30 hover:bg-primary/[0.02] active:scale-[.99] transition-all"
    >
      <div className="w-11 h-11 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0 text-xl">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm text-foreground">{title}</p>
        <p className="text-xs text-muted-foreground mt-0.5 truncate">{description}</p>
        {badge && (
          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full mt-1 inline-block ${badgeColors[badgeColor]}`}>
            {badge}
          </span>
        )}
      </div>
      {children}
      <ChevronLeft className="w-4 h-4 text-muted-foreground flex-shrink-0 rtl-flip" />
    </button>
  );
}